import { render, staticRenderFns } from "./the.vue?vue&type=template&id=bc721458&scoped=true&"
import script from "./the.vue?vue&type=script&lang=js&"
export * from "./the.vue?vue&type=script&lang=js&"
import style0 from "./the.vue?vue&type=style&index=0&id=bc721458&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc721458",
  null
  
)

export default component.exports